import React from "react";
import {
  Typography,
  Link,
  Button,
  ButtonGroup
} from "@one-thd/sui-atomic-components";
import { TERMS_OF_USE_URL, PRIVACY_AND_SECURITY_STATEMENT_URL } from "../../../utils/urls";
import { selectAutomationIdBasedOnComponent } from "../../../utils/automationIds"

const OtpTermsAndConditionsView = (props) => {
  const { 
    phone = "",
    onCancelModal,
    verifyExistingPhone,
    setCurModalView
  } = props;

  return (
    <div className="sui-grid sui-gap-4">
        <section>
            <Typography>To verify your phone number we need to send a one-time verification code to</Typography>
        </section>
        <section>
            <Typography weight="bold"> {phone} </Typography>
        </section>
        <section>
            <Typography color="subtle" variant="body-xs" weight="bold"> Message and data rates may apply </Typography>
        </section>
        <section className=" sui-gap-y-1">
            <span className="sui-mx-1">
                <Link variant="body-xs" target="_blank" href={TERMS_OF_USE_URL}>Terms of Use</Link>
            </span>
            <span className="sui-mx-1">
                <Link variant="body-xs" target="_blank" href={PRIVACY_AND_SECURITY_STATEMENT_URL}>Privacy and Security Statement</Link>
            </span>
        </section>
        <section>
            <ButtonGroup orientation="vertical">
                <Button data-automation-id={selectAutomationIdBasedOnComponent("phoneVerification", "sendCode")} onClick={()=>{verifyExistingPhone(); setCurModalView("newPhoneVerificationSms");}} fullWidth variant="primary"> Send Code </Button>
                <Button data-automation-id={selectAutomationIdBasedOnComponent("phoneVerification", "cancel")} onClick={onCancelModal} fullWidth variant="secondary"> Cancel </Button>
            </ButtonGroup>
        </section>
    </div>
  )
}
 
export default OtpTermsAndConditionsView;